import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

type Props = {
  branch: string;
  open: boolean;
  onClose: () => void;
  onReInit: (branch: string) => void;
};

export const ReInitValidationDialog: React.FC<Props> = (props) => {
  const [branch, setBranch] = React.useState(props.branch);

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>Re-Init validation from git</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Git branch for validation"
          value={branch}
          variant="standard"
          onChange={(event) => {
            setBranch(event.target.value);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button
          disabled={branch.length < 3}
          onClick={() => {
            props.onReInit(branch);
          }}
        >
          Re-Init
        </Button>
      </DialogActions>
    </Dialog>
  );
};
